export default "__VITE_ASSET__yYTvsoN___"